import { render, staticRenderFns } from "./EditPasswdDlg.vue?vue&type=template&id=33618030"
import script from "./EditPasswdDlg.vue?vue&type=script&lang=js"
export * from "./EditPasswdDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports